import { useDisplayGlucoseUnit } from "./useDisplayGlucoseUnit"

export function useReadableGlucoseUnit(): string {
  const displayGlucoseUnit = useDisplayGlucoseUnit()
  return displayGlucoseUnit()
}
